module.exports = __webpack_public_path__ + "fonts/OpenSans-Regular.8df00d61.ttf";